export const enum TileStatus {
  Normal, // same as status={undefined}
  RestrictedVisibility,
  Deleted,
  NotLicensed,
  RequiresContext,
}
